import script from "./EditAnnouncementPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./EditAnnouncementPanel.vue?vue&type=script&setup=true&lang=js"

import "./EditAnnouncementPanel.vue?vue&type=style&index=0&id=65097348&lang=scss"

export default script